import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    refresh: false
}

export const onboardDetailsRefreshReducerSlice = createSlice({
    name: 'onboard/onboardDetailsRefresh',
    initialState,
    reducers: {
        setRefresh: (state, action) => {
            return { ...state, ...action.payload };
        }
    }
})

export const { setRefresh } = onboardDetailsRefreshReducerSlice.actions;
export default onboardDetailsRefreshReducerSlice.reducer